import { CommonModule } from '@angular/common'
import { Component, inject } from '@angular/core'
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { select, Store } from '@ngrx/store'
import {
  selectError,
  selectLoading,
  selectShowThankYouMessage
} from '../../../store/auth/auth.state'
import { register, resetThankYouMessage } from '../../../store/auth/auth.actions'
import { ActivatedRoute, RouterModule } from '@angular/router'
import { Actions } from '@ngrx/effects'
import { Observable } from 'rxjs'
import { eps } from '../../../services/url.service'
import { environment } from '../../../../environments/environment'
import { StrictEmailDirective } from '../../../directives/strict-email.directive'
import { noSpacesValidator } from '../../../validators/no-spaces.validators'
import { noLeadingTrailingSpaces } from '../../../validators/no-leadingTraillingSpace.validators'
import { SharedModule } from '../../../shared/shared.module'

@Component({
  selector: 'app-registration',
  imports: [
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    RouterModule,
    StrictEmailDirective,
    SharedModule
  ],
  templateUrl: './registration.component.html',
  styleUrl: './registration.component.scss'
})
export class RegistrationComponent {
  form: FormGroup
  eps = eps
  planId!: string
  // public token = ''
  // public id = ''
  // // public locationId: string = "762d6a45-1edb-4231-9147-aa98e02c6c32";
  currentYear: number
  errorMessage$
  isLoading$
  actions$ = inject(Actions)
  showThankYouMessage$

  constructor(
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
    private store: Store,
    private route: ActivatedRoute
  ) {
    const planId = this.route.snapshot.paramMap.get('id')
    if (planId) this.planId = planId

    this.currentYear = new Date().getFullYear()
    this.errorMessage$ = this.store.pipe(select(selectError))
    this.isLoading$ = this.store.pipe(select(selectLoading))
    this.form = this.fb.group({
      firstName: ['', [Validators.required, Validators.maxLength(50), noLeadingTrailingSpaces()]],
      lastName: ['', [Validators.required, Validators.maxLength(50), noLeadingTrailingSpaces()]],
      email: ['', [Validators.required, Validators.email, noLeadingTrailingSpaces()]],
      mobile: ['', [Validators.required, this.phoneNumberValidator(), noLeadingTrailingSpaces()]], // Custom validator
      businessName: [
        '',
        [Validators.required, Validators.maxLength(100), noLeadingTrailingSpaces()]
      ],
      planId: [this.planId, [Validators.required, noLeadingTrailingSpaces()]]
    })

    // this.actions$.pipe(ofType(registerSuccess)).subscribe(() => {
    //   this.isLoading = false
    //   this.form.reset()
    // })
    // this.actions$.pipe(ofType(registerFailure)).subscribe(() => {
    //   this.isLoading = false
    //   // this.form.reset()
    // })

    this.showThankYouMessage$ = this.store.pipe(select(selectShowThankYouMessage))
  }
  // // Method to handle form submission
  register() {
    if (this.form.valid) {
      // this.isLoading = true
      this.store.dispatch(register(this.form.value))
    }
  }
  phoneNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const phoneNumber = control.value
      // This regex allows for a '+' followed by 1 to 3 digits (country code),
      // optionally followed by a space, and then 1 to 14 digits (the phone number).
      const valid = /^\+\d{1,3} ?\d{1,14}$/.test(phoneNumber)
      return valid ? null : { invalidPhoneNumber: true }
    }
  }
  getErrorMessage(controlName: string): string | null {
    const control = this.form.get(controlName)
    // console.log('control name', control)
    if (control && control.touched && control.invalid) {
      if (control.hasError('required')) {
        return 'This field is required'
      }
      if (control.hasError('email')) {
        return 'Please enter a valid email address'
      }
      if (control.hasError('invalidPhoneNumber')) {
        return 'Invalid phone number format. Valid format ex.: +91 99xxxxxxxx'
      }
    }
    return null // No error
  }

  get copyrightText(): SafeHtml {
    const copyrightSymbol = '\u00A9' // Unicode for ©
    const text =
      this.currentYear === 2025
        ? `Copyright ${copyrightSymbol} 2025 - <a href="https://avrtechno.com" class="hover-a">AVR Software Pvt. Ltd.</a>`
        : `Copyright ${copyrightSymbol} 2025 - ${this.currentYear} - <a href="https://avrtechno.com" class="hover-a">AVR Software Pvt. Ltd.</a>`
    return this.sanitizer.bypassSecurityTrustHtml(text)
  }

  handleSignInClick(): void {
    this.store.dispatch(resetThankYouMessage())
  }
}
